import React, { Component } from 'react';
import { Button, Container, Grid, Menu, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { fetchRandomProgrammingJoke } from './utility/fetchJoke';
import { fetchRandomFact } from './utility/fetchrandomFact';

const StyledContainer = styled(Container)`
  margin-top: 5%;
`;

export default class MenuExampleTabularOnLeft extends Component {
  state = {
    activeItem: 'bio',
    segmentText: {
      bio:
        '<h2>Hi, my name is Tahmid</h2>' +
        "<h4>I like to play with computers. I am a Senior Software Engineer at <a href='https://www.lightspeedhq.com/' target='_blank'>Lightspeed Commerce</a>, and my team name is <strong>Developer Experience(DX)</strong>. I write tools to make other developers' lives easier, if not harder." +
        '<br><br>The absence of fancy design and styling on my website makes it evident that I primarily work in the backend. But, like a wise man once said, looks can be deceiving!' +
        '<br><br>I am a full-stack Engineer (no, my stack does not overflow if you give me a task) with experience in Python, Node, and ReactJS. When I said full-stack, I also meant infrastructure.' +
        '<br><br>In my free time, I like to break stuff in the name of building something beautiful, and I often justify the damage by saying, "phoenix rising from the ashes." Also, I am highly interested in problem-solving and like to read about various Computer Science stuff.' +
        '</h4><br>Did I mention that I can discuss <strong>Distributed System Design</strong> over coffee for hours?',
      links:
        '<h4>What you seek is seeking you!</h4>' +
        '<strong><a href="https://github.com/goldenrati0" target="_blank">Github</a></strong><br>' +
        '<strong><a href="https://www.linkedin.com/in/tahmid-choyon/" target="_blank">LinkedIn</a></strong><br>',
      excusesIHaveUsed:
        '<strong>1. Oops! 💀</strong>' +
        '<br><br><strong>2. Worked on my machine! 🐳</strong>' +
        '<br><br><strong>3. Restarting should fix this. 🔁</strong>' +
        '<br><br><strong>4. return Response(status=200, body={"error": "oops!"})</strong>' +
        '<br><br><strong>5. What could go wrong with this small deployment on Friday? 🤡</strong>' +
        "<br><br><strong>6. It doesn't need tests. 🤡</strong>" +
        '<br><br><strong>7. Python is slow!! 😫</strong>',
      joke: '<h3>If you are seeing this, the app is broken!!!</h3>',
      randomFact: '<h3>If you are seeing this, the app is broken!!!</h3>',
    },
    randomFactSegmentLoading: false,
  };

  handleItemClick = (e, { name }) => {
    if (['joke', 'newJokeBtn'].includes(name)) {
      this.populateJoke();
      this.setState({ activeItem: 'joke' });
    } else if (['randomFact', 'newRandomFactBtn'].includes(name)) {
      this.getNewRandomFact();
      this.setState({ activeItem: 'randomFact' });
    } else {
      this.setState({ activeItem: name });
    }
  };

  getNewRandomFact = () => {
    this.setState({ randomFactSegmentLoading: true });
    fetchRandomFact()
      .then(response => {
        const { fact } = response.data;
        const formattedFact = `<h3>${fact}</h3><h5>https://uselessfacts.jsph.pl/</h5>`;

        const prevSegmentText = this.state.segmentText;
        this.setState({
          segmentText: { ...prevSegmentText, randomFact: formattedFact },
          randomFactSegmentLoading: false,
        });
      })
      .catch(error => {
        const formattedFact = `<h3>${'Slow down, Too many requests!!'}</h3>`;

        const prevSegmentText = this.state.segmentText;
        this.setState({
          segmentText: { ...prevSegmentText, randomFact: formattedFact },
          randomFactSegmentLoading: false,
        });
      });
  };

  populateJoke = () => {
    const { setup, punchline } = fetchRandomProgrammingJoke();

    const formattedJoke = `<h3>${setup}</h3><h4>${punchline}</h4>`;
    const prevSegmentText = this.state.segmentText;
    this.setState({ segmentText: { ...prevSegmentText, joke: formattedJoke } });
  };

  render() {
    const { activeItem, segmentText, randomFactSegmentLoading } = this.state;

    return (
      <StyledContainer textAlign={'center'}>
        <Grid>
          <Grid.Column width={4}>
            <Menu fluid vertical tabular>
              <Menu.Item
                name='bio'
                active={activeItem === 'bio'}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                content={'Online Profiles'}
                name='links'
                active={activeItem === 'links'}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name='excusesIHaveUsed'
                active={activeItem === 'excusesIHaveUsed'}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name='joke'
                active={activeItem === 'joke'}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name='randomFact'
                active={activeItem === 'randomFact'}
                onClick={this.handleItemClick}
              />
            </Menu>
          </Grid.Column>

          <Grid.Column stretched width={12}>
            {['joke', 'randomFact'].includes(activeItem) ? (
              activeItem === 'joke' ? (
                <Segment.Group>
                  <Segment.Group>
                    <Segment
                      dangerouslySetInnerHTML={{ __html: segmentText[activeItem] }}
                    />
                  </Segment.Group>
                  <Segment>
                    <Segment.Inline>
                      <Button.Group>
                        <Button
                          name='newJokeBtn'
                          labelPosition='left'
                          icon='angle double right'
                          content='Next'
                          onClick={this.handleItemClick}
                        />
                      </Button.Group>
                    </Segment.Inline>
                  </Segment>
                </Segment.Group>
              ) : (
                <Segment.Group>
                  <Segment.Group>
                    <Segment
                      loading={randomFactSegmentLoading}
                      dangerouslySetInnerHTML={{ __html: segmentText[activeItem] }}
                    />
                  </Segment.Group>
                  <Segment>
                    <Segment.Inline>
                      <Button.Group>
                        <Button
                          size='small'
                          name='newRandomFactBtn'
                          labelPosition='left'
                          icon='angle double right'
                          content='Next'
                          onClick={this.handleItemClick}
                        />
                      </Button.Group>
                    </Segment.Inline>
                  </Segment>
                </Segment.Group>
              )
            ) : (
              <Segment dangerouslySetInnerHTML={{ __html: segmentText[activeItem] }} />
            )}
          </Grid.Column>
        </Grid>
      </StyledContainer>
    );
  }
}
